
import { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import ThemeToggle from "./ThemeToggle";
import useAuth from "../helper/useAuth";
const HeaderOne = ({
  setOpenGetDemoModal,
  setOpenLoginModal,
  setOpenRegisterModal,
}) => {
  const { t, i18n } = useTranslation();
  const [active, setActive] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const accountMenuRef = useRef(null);
  const mobileAccountMenuRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();
  const getLocalizedPath = (lang, path = "") => {
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    if (lang === "hy") {
      return normalizedPath === "/" ? "/" : normalizedPath;
    }
    return normalizedPath === "/" ? `/${lang}` : `/${lang}${normalizedPath}`;
  };
  const { isAuthenticated, logout } = useAuth();

  const handleLogout = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      await logout(i18n.language || "en");
      navigate(`/${i18n.language}`, { replace: true });
    } finally {
      setLoggingOut(false);
      setAccountOpen(false);
    }
  };

  const profilePath = getLocalizedPath(i18n.language, "/profile");
  const ticketsPath = getLocalizedPath(i18n.language, "/online-booking/tickets");
  const bookingPath = getLocalizedPath(i18n.language, "/online-booking");

  useEffect(() => {
    var offCanvasNav = document.getElementById("offcanvas-navigation");
    var menuExpand = offCanvasNav.querySelectorAll(
      ".has-submenu > .nav-menu__link"
    );
    var numMenuExpand = menuExpand.length;

    function sideMenuExpand() {
      if (this.parentElement.classList.contains("active") === true) {
        this.parentElement.classList.remove("active");
      } else {
        for (let i = 0; i < numMenuExpand; i++) {
          menuExpand[i].parentElement.classList.remove("active");
        }
        this.parentElement.classList.add("active");
      }
    }

    for (let i = 0; i < numMenuExpand; i++) {
      menuExpand[i].addEventListener("click", sideMenuExpand);
    }

  }, []);


  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else {
        setScroll(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!accountOpen) return;

    const handlePointerDown = (event) => {
      const clickedDesktopMenu = accountMenuRef.current?.contains(event.target);
      const clickedMobileMenu = mobileAccountMenuRef.current?.contains(event.target);
      if (!clickedDesktopMenu && !clickedMobileMenu) {
        setAccountOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setAccountOpen(false);
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [accountOpen]);

  const mobileMenu = () => {
    setAccountOpen(false);
    setActive(!active);
  };

  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang);

    const pathParts = location.pathname.split("/").filter(Boolean);
    const hasLocalePrefix = pathParts[0] === "en";
    const routeParts = hasLocalePrefix ? pathParts.slice(1) : pathParts;
    const routePath = routeParts.length ? `/${routeParts.join("/")}` : "/";

    navigate(getLocalizedPath(lang, routePath) + location.search, { replace: true });
  };
  const moveHomeClick = (event, href) => {
    event.preventDefault();
    const homePath = getLocalizedPath(i18n.language, "/");
    if (location.pathname !== homePath) {
      navigate(homePath, { replace: false });
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const element = document.querySelector(href);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const closeMobileMenu = () => {
    setActive(false);
  }

  return (
    <>
      <div className="overlay"></div>
      <div
        className={`side-overlay ${active && "show"}`}
        onClick={closeMobileMenu}
        role="presentation"
      ></div>
      {/* ==================== Header Start Here ==================== */}
      <header className={`header ${scroll ? "fixed-header" : ""} `}>
        <div className="container container-full">
          <nav className="header-inner flx-between">
            {/* Logo Start */}
            <div className="logo">
              <Link to={getLocalizedPath(i18n.language, "/")} className="link white-version" >
                    <img src="/assets/images/logo/logo-two.png" alt="Logo" />
              </Link>
              <Link to={getLocalizedPath(i18n.language, "/")} className="link dark-version">
                    <img src="/assets/images/logo/white-logo.png" alt="Logo" />
              </Link>
            </div>
            {/* Logo End  */}
            {/* Menu Start  */}
            <div className="header-menu d-lg-block d-none">
              <ul className="nav-menu flx-align">
                <li className="nav-menu__item">
                  <a className="nav-menu__link" href="#about" onClick={(event) => moveHomeClick(event, "#about")}>{t('about')}</a>
                </li>
                <li className="nav-menu__item">
                  <a className="nav-menu__link" href="#solutions" onClick={(event) => moveHomeClick(event, "#solutions")}>{t('solutions')}</a>
                </li>

                <li className="nav-menu__item">
                  {/* has-submenu */}
                  <NavLink to={getLocalizedPath(i18n.language, "/blog")} className="nav-menu__link">
                    {t('blog')}
                  </NavLink>
                </li>
                <li className="nav-menu__item">
                  <NavLink to={getLocalizedPath(i18n.language, "/contact")} className="nav-menu__link">
                    {t('contact')}
                  </NavLink>
                </li>
                {/* <li className="nav-menu__item">
                  <NavLink
                    to={`/${i18n.language}/demo`}
                    className="nav-menu__link d-inline-flex align-items-center gap-2"
                  >
                    <i
                      className="las la-flask"
                      style={{ fontSize: "1.1rem" }}
                      aria-hidden="true"
                    />
                    {t('header.demoEnv')}
                    <span
                      className="badge fw-700 px-2 rounded-pill"
                      style={{
                        backgroundColor: "hsl(263 70% 55%)",
                        color: "#fff",
                        fontSize: 9,
                        letterSpacing: "0.08em",
                      }}
                    >
                      DEMO
                    </span>
                  </NavLink>
                </li> */}

              </ul>
            </div>
            {/* Menu End  */}
            {/* Header Right start */}
            <div className="header-right flx-align">
              {/* Light Dark Mode */}
              <ThemeToggle />
              {/* Light Dark Mode */}
              <div className="header-right__inner gap-2 flx-align d-lg-flex d-none">
                {isAuthenticated ? (
                  <div className="header-account-menu" ref={accountMenuRef}>
                    <button
                      type="button"
                      className="btn btn-outline-main pill fw-500 header-account-trigger"
                      onClick={() => setAccountOpen((value) => !value)}
                      aria-expanded={accountOpen}
                      aria-haspopup="menu"
                    >
                      <span className="header-account-avatar" aria-hidden="true">
                        <i className="las la-user" />
                      </span>
                      {t("profile.headerBtn")}
                      <i
                        className={`las la-angle-${accountOpen ? "up" : "down"}`}
                        aria-hidden="true"
                      />
                    </button>
                    <div
                      className={`header-account-dropdown ${accountOpen ? "is-open" : ""}`}
                      role="menu"
                    >
                      <NavLink
                        to={profilePath}
                        className="header-account-dropdown__item"
                        role="menuitem"
                        onClick={() => setAccountOpen(false)}
                      >
                        <i className="las la-user-circle" aria-hidden="true" />
                        <span>
                          <strong>{t("profile.headerBtn")}</strong>
                          <small>{t("header.accountMenu.profileHint")}</small>
                        </span>
                      </NavLink>
                      <NavLink
                        to={ticketsPath}
                        className="header-account-dropdown__item"
                        role="menuitem"
                        onClick={() => setAccountOpen(false)}
                      >
                        <i className="las la-receipt" aria-hidden="true" />
                        <span>
                          <strong>{t("header.accountMenu.bookings")}</strong>
                          <small>{t("header.accountMenu.bookingsHint")}</small>
                        </span>
                      </NavLink>
                      <NavLink
                        to={bookingPath}
                        className="header-account-dropdown__item"
                        role="menuitem"
                        onClick={() => setAccountOpen(false)}
                      >
                        <i className="las la-calendar-plus" aria-hidden="true" />
                        <span>
                          <strong>{t("header.onlineBooking")}</strong>
                          <small>{t("header.accountMenu.newBookingHint")}</small>
                        </span>
                      </NavLink>
                      <div className="header-account-dropdown__divider" />
                      <button
                        type="button"
                        className="header-account-dropdown__item header-account-dropdown__item--danger"
                        role="menuitem"
                        onClick={handleLogout}
                        disabled={loggingOut}
                      >
                        <i className="las la-sign-out-alt" aria-hidden="true" />
                        <span>
                          <strong>
                            {loggingOut
                              ? t("authModal.logout.loading")
                              : t("authModal.logout.btn")}
                          </strong>
                        </span>
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    <button
                      type="button"
                      className="btn btn-outline-main pill fw-500"
                      onClick={() => setOpenLoginModal(true)}
                    >
                      {t("login")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-main pill"
                      onClick={() => setOpenRegisterModal(true)}
                    >
                      <span className="icon-left icon">
                        <img src="/assets/images/icons/user.svg" alt="" />
                      </span>
                      {t("register")}
                    </button>
                  </>
                )}
                <NavLink
                  id="demo-button-header"
                  to={bookingPath}
                  className="btn btn-main pill"
                >
                  <span className="icon-left icon">
                    <img src="/assets/images/icons/ticket.png" alt="" style={{width: 17, height: 17}} />
                  </span>
                  {t('header.onlineBooking')}
                </NavLink>
                <div className="language-select d-flex align-items-center select-has-icon">
                          <img src={`/assets/images/thumbs/${i18n.language}-flag.png`} alt="" className="lng-icon" />

                  <div className="select py-0 ps-2 border-0 fw-500">{i18n.language === 'en' ? t('language.english') : t('language.armenian')}
                    <ul>
                      <li onClick={() => handleChangeLanguage('en')}>{t('language.english')}</li>
                      <li onClick={() => handleChangeLanguage('hy')}>{t('language.armenian')}</li>
                    </ul>
                  </div>
                </div>
              </div>
              {isAuthenticated ? (
                <div
                  className="mobile-header-account d-lg-none"
                  ref={mobileAccountMenuRef}
                >
                  <button
                    type="button"
                    className="mobile-header-account__trigger"
                    onClick={() => {
                      setActive(false);
                      setAccountOpen((value) => !value);
                    }}
                    aria-expanded={accountOpen}
                    aria-haspopup="menu"
                    aria-label={t("profile.headerBtn")}
                  >
                    <i className="las la-user" aria-hidden="true" />
                  </button>
                  <div
                    className={`header-account-dropdown mobile-header-account__dropdown ${accountOpen ? "is-open" : ""}`}
                    role="menu"
                  >
                    <NavLink
                      to={profilePath}
                      className="header-account-dropdown__item"
                      role="menuitem"
                      onClick={() => setAccountOpen(false)}
                    >
                      <i className="las la-user-circle" aria-hidden="true" />
                      <span>
                        <strong>{t("profile.headerBtn")}</strong>
                        <small>{t("header.accountMenu.profileHint")}</small>
                      </span>
                    </NavLink>
                    <NavLink
                      to={ticketsPath}
                      className="header-account-dropdown__item"
                      role="menuitem"
                      onClick={() => setAccountOpen(false)}
                    >
                      <i className="las la-receipt" aria-hidden="true" />
                      <span>
                        <strong>{t("header.accountMenu.bookings")}</strong>
                        <small>{t("header.accountMenu.bookingsHint")}</small>
                      </span>
                    </NavLink>
                    <NavLink
                      to={bookingPath}
                      className="header-account-dropdown__item"
                      role="menuitem"
                      onClick={() => setAccountOpen(false)}
                    >
                      <i className="las la-calendar-plus" aria-hidden="true" />
                      <span>
                        <strong>{t("header.onlineBooking")}</strong>
                        <small>{t("header.accountMenu.newBookingHint")}</small>
                      </span>
                    </NavLink>
                    <div className="header-account-dropdown__divider" />
                    <button
                      type="button"
                      className="header-account-dropdown__item header-account-dropdown__item--danger"
                      role="menuitem"
                      onClick={handleLogout}
                      disabled={loggingOut}
                    >
                      <i className="las la-sign-out-alt" aria-hidden="true" />
                      <span>
                        <strong>
                          {loggingOut
                            ? t("authModal.logout.loading")
                            : t("authModal.logout.btn")}
                        </strong>
                      </span>
                    </button>
                  </div>
                </div>
              ) : null}
              <button
                type="button"
                className="toggle-mobileMenu d-lg-none"
                onClick={mobileMenu}
              >
                <i className="las la-bars" />
              </button>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}

      <div className={`mobile-menu d-lg-none d-block ${active && "active"}`}>
        <button type="button" className="close-button text-body hover-text-main" onClick={mobileMenu}>
          <i className="las la-times" />
        </button>
        <div className="mobile-menu__inner">
            <div className="mobile-menu__logo">
              <Link to={getLocalizedPath(i18n.language, "/")} className="link white-version" >
                    <img src="/assets/images/logo/logo-two.png" alt="Logo" />
              </Link>
              <Link to={getLocalizedPath(i18n.language, "/")} className="link dark-version">
                    <img src="/assets/images/logo/white-logo.png" alt="Logo" />
              </Link>
            </div>
          <div className="mobile-menu__menu">
            <ul
              className="nav-menu flx-align nav-menu--mobile"
              id="offcanvas-navigation"
            >
              <li className="nav-menu__item">
                <Link to={getLocalizedPath(i18n.language, "/blog")} className="nav-menu__link" onClick={closeMobileMenu}>
                  {t('blog')}
                  {/* activePage */}
                </Link>
              </li>
              <li className="nav-menu__item">
                <NavLink to={getLocalizedPath(i18n.language, "/contact")} className="nav-menu__link" onClick={closeMobileMenu}>
                  {t('contact')}
                </NavLink>
              </li>
              {/* <li className="nav-menu__item">
                <NavLink
                  to={`/${i18n.language}/demo`}
                  className="nav-menu__link d-inline-flex align-items-center gap-2"
                  onClick={closeMobileMenu}
                >
                  <i
                    className="las la-flask"
                    style={{ fontSize: "1.1rem" }}
                    aria-hidden="true"
                  />
                  {t('header.demoEnv')}
                  <span
                    className="badge fw-700 px-2 rounded-pill"
                    style={{
                      backgroundColor: "hsl(263 70% 55%)",
                      color: "#fff",
                      fontSize: 9,
                      letterSpacing: "0.08em",
                    }}
                  >
                    DEMO
                  </span>
                </NavLink>
              </li> */}
            </ul>
            <div className="header-right__inner d-lg-none my-3 gap-2 d-flex flx-align flex-wrap">
              {!isAuthenticated ? (
                <>
                  <button
                    type="button"
                    className="btn btn-outline-light btn-sm pill fw-500"
                    onClick={() => {
                      setOpenLoginModal(true);
                      closeMobileMenu();
                    }}
                  >
                    {t("login")}
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-main btn-sm pill fw-500"
                    onClick={() => {
                      setOpenRegisterModal(true);
                      closeMobileMenu();
                    }}
                  >
                    {t("register")}
                  </button>
                </>
              ) : null}

                <NavLink
                  id="demo-button-header"
                  to={bookingPath}
                  onClick={() => {
                    closeMobileMenu();
                  }}
                  className="btn btn-main pill"
                >
                  <span className="icon-left icon">
                    <img src="/assets/images/icons/ticket.png" alt="" style={{width: 17, height: 17}} />
                  </span>
                  {t('header.onlineBooking')}
                </NavLink>

              <div className="language-select d-flex align-items-center select-has-icon">
                          <img src={`/assets/images/thumbs/${i18n.language}-flag.png`} alt="" className="lng-icon" />
                <div className="select py-0 ps-2 border-0 fw-500">{i18n.language === 'en' ? t('language.english') : t('language.armenian')}
                  <ul>
                    <li onClick={() => handleChangeLanguage('en')}>{t('language.english')}</li>
                    <li onClick={() => handleChangeLanguage('hy')}>{t('language.armenian')}</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <style>
        {`
          .header-account-menu {
            position: relative;
            flex-shrink: 0;
          }

          .header-account-trigger {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            min-height: 46px;
          }

          .header-account-avatar {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: rgba(0, 209, 178, 0.12);
            color: hsl(166 100% 42%);
            flex-shrink: 0;
          }

          .header-account-dropdown {
            position: absolute;
            top: calc(100% + 12px);
            right: 0;
            width: min(310px, calc(100vw - 24px));
            padding: 10px;
            border-radius: 18px;
            background: #ffffff;
            border: 1px solid rgba(15, 23, 42, 0.08);
            box-shadow: 0 22px 60px rgba(15, 23, 42, 0.18);
            opacity: 0;
            visibility: hidden;
            transform: translateY(-6px);
            transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s ease;
            z-index: 120;
          }

          .header-account-dropdown.is-open {
            opacity: 1;
            visibility: visible;
            transform: translateY(0);
          }

          .header-account-dropdown::before {
            content: "";
            position: absolute;
            top: -7px;
            right: 34px;
            width: 14px;
            height: 14px;
            transform: rotate(45deg);
            background: #ffffff;
            border-left: 1px solid rgba(15, 23, 42, 0.08);
            border-top: 1px solid rgba(15, 23, 42, 0.08);
          }

          .header-account-dropdown__item {
            width: 100%;
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 11px 12px;
            border-radius: 12px;
            border: 0;
            background: transparent;
            color: #111827;
            text-decoration: none;
            text-align: left;
            transition: background 0.14s ease, color 0.14s ease;
          }

          .header-account-dropdown__item:hover,
          .header-account-dropdown__item:focus {
            background: rgba(0, 209, 178, 0.1);
            color: #08111f;
          }

          .header-account-dropdown__item i {
            width: 34px;
            height: 34px;
            border-radius: 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: rgba(15, 23, 42, 0.06);
            color: hsl(166 100% 34%);
            font-size: 1.15rem;
            flex-shrink: 0;
          }

          .header-account-dropdown__item strong {
            display: block;
            font-size: 0.92rem;
            line-height: 1.2;
            font-weight: 700;
          }

          .header-account-dropdown__item small {
            display: block;
            margin-top: 2px;
            color: #6b7280;
            font-size: 0.78rem;
            line-height: 1.35;
          }

          .header-account-dropdown__divider {
            height: 1px;
            background: rgba(15, 23, 42, 0.08);
            margin: 8px 4px;
          }

          .header-account-dropdown__item--danger {
            cursor: pointer;
          }

          .header-account-dropdown__item--danger i {
            color: #ef4444;
            background: rgba(239, 68, 68, 0.1);
          }

          .header-account-dropdown__item--danger:hover,
          .header-account-dropdown__item--danger:focus {
            background: rgba(239, 68, 68, 0.08);
            color: #991b1b;
          }

          .mobile-header-account {
            position: relative;
            display: inline-flex;
            flex-shrink: 0;
          }

          .mobile-header-account__trigger {
            width: 42px;
            height: 42px;
            border-radius: 50%;
            border: 1px solid rgba(0, 209, 178, 0.48);
            background: rgba(0, 209, 178, 0.12);
            color: hsl(166 100% 45%);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 1.25rem;
            transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease;
          }

          .mobile-header-account__trigger:hover,
          .mobile-header-account__trigger:focus,
          .mobile-header-account__trigger[aria-expanded="true"] {
            background: hsl(166 100% 42%);
            border-color: hsl(166 100% 42%);
            color: #061415;
          }

          .mobile-header-account__dropdown {
            top: calc(100% + 14px);
            right: -42px;
            z-index: 140;
          }

          @media (max-width: 575px) {
            .header-right {
              gap: 10px;
            }

            .mobile-header-account__trigger {
              width: 40px;
              height: 40px;
            }

            .mobile-header-account__dropdown {
              right: -56px;
              width: min(300px, calc(100vw - 28px));
            }

            .mobile-header-account__dropdown::before {
              right: 74px;
            }
          }

          html[data-theme="light"] .header-account-dropdown {
            background: #131517;
            border-color: rgba(255, 255, 255, 0.1);
            box-shadow: 0 22px 60px rgba(0, 0, 0, 0.38);
          }

          html[data-theme="light"] .header-account-dropdown::before {
            background: #131517;
            border-color: rgba(255, 255, 255, 0.1);
          }

          html[data-theme="light"] .header-account-dropdown__item {
            color: #f8fafc;
          }

          html[data-theme="light"] .header-account-dropdown__item:hover,
          html[data-theme="light"] .header-account-dropdown__item:focus {
            background: rgba(0, 209, 178, 0.12);
            color: #ffffff;
          }

          html[data-theme="light"] .header-account-dropdown__item i {
            background: rgba(255, 255, 255, 0.08);
            color: hsl(166 100% 47%);
          }

          html[data-theme="light"] .header-account-dropdown__item small {
            color: rgba(255, 255, 255, 0.68);
          }

          html[data-theme="light"] .header-account-dropdown__divider {
            background: rgba(255, 255, 255, 0.1);
          }

          html[data-theme="light"] .header-account-dropdown__item--danger {
            color: #fecaca;
          }

          html[data-theme="light"] .header-account-dropdown__item--danger i {
            background: rgba(239, 68, 68, 0.13);
            color: #f87171;
          }
        `}
      </style>
    </>
  );
};

export default HeaderOne;

